<div class="body-padding">

  <div class="flex flex-col  items-baseline  mb-4">
    <div class="text-sm	text-zinc-500">Dashboard/Invoices</div>
    <h1 class="general-font text-5xl font-bold text-gray-900">Invoices</h1>
  </div>

  <div class="flex gap-4 items-baseline align-baseline">
    <div class="w-fit mr-3">
      <label for="invoices-search-input" class="block mb-2 text-sm font-medium text-gray-900">Search</label>
      <div id="invoices-search-container" class="flex items-center h-fit border border-gray-300 rounded w-fit bg-gray-50">
        <svg class="ml-2 h-5 w-5 pr-1 text-gray-600" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Left Icon">
            <path id="Vector" d="M14.5 15L10.5 11M6.5 13C3.18629 13 0.5 10.3137 0.5 7C0.5 3.68629 3.18629 1 6.5 1C9.81371 1 12.5 3.68629 12.5 7C12.5 10.3137 9.81371 13 6.5 13Z" stroke="#1D1929"/>
          </g>
        </svg>
        <input id="invoices-search-input" type="text" placeholder="Fuzzy search..." class="input-custom" />
      </div>
    </div>
  </div>
  <div id="invoices-tabs-header" class="border-b border-gray-200">
    <ul class="flex flex-wrap -mb-px text-sm font-medium text-center" id="invoices-tabs" data-tabs-toggle="#invoices-tabs-content" role="tablist">
      <li class="me-2" role="presentation">
        <button class="general-font inline-block p-4  rounded-t-lg" id="profile-tab" data-tabs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Pending</button>
      </li>
      <li class="me-2" role="presentation">
        <button class="general-font inline-block p-4  rounded-t-lg  hover:text-gray-600 hover:border-gray-300 " id="dashboard-tab" data-tabs-target="#dashboard" type="button" role="tab" aria-controls="dashboard" aria-selected="false">Shipped</button>
      </li>
    </ul>
  </div>
  <div id="default-tab-content">
    <div class="hidden rounded-lg" id="profile" role="tabpanel" aria-labelledby="profile-tab">
      <div class="overflow-x-auto">
      </div>
    </div>
    <div class="hidden p-4 rounded-lg bg-gray-50 " id="dashboard" role="tabpanel" aria-labelledby="dashboard-tab">
      <div class="overflow-x-auto">
        To be implemented
      </div>
    </div>
  </div>
</div>
